module.exports = __webpack_public_path__ + "img/info_inverted.8ea8befd.svg";